import { render, staticRenderFns } from "./study-participants.vue?vue&type=template&id=afe491ea&scoped=true&"
import script from "./study-participants.vue?vue&type=script&lang=js&"
export * from "./study-participants.vue?vue&type=script&lang=js&"
import style0 from "./study-participants.vue?vue&type=style&index=0&id=afe491ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe491ea",
  null
  
)

component.options.__file = "study-participants.vue"
export default component.exports